export enum ProviderFacilityType {
  FUNERAL_PARLOUR = '47',
  REPATRIATION_AGENT = '48',
}
